var fields = $('[data-address-field]');

if (fields.length > 0) {
  require.ensure('../address_field/address_controller', function(require) {
    var AddressController = require('../address_field/address_controller');
    return new AddressController();
  });
}

$('html').on('loaded:dialog.nearme', function() {
  require.ensure('../address_field/address_controller', function(require) {
    var AddressController = require('../address_field/address_controller');
    return new AddressController('.dialog');
  });
});



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/address.initializer.js